import { isSSR } from "./isSSR";

/**
 * A function to check if using Next.js, useful when wanting to support to platforms.
 * @returns {boolean}
 */
export var isUsingNext = function isUsingNext() {
  if (isSSR()) {
    var _process;
    return !!((_process = process) !== null && _process !== void 0 && (_process = _process.env) !== null && _process !== void 0 && _process.__NEXT_PROCESSED_ENV);
  }
  if (!isSSR()) {
    var _document;
    return ((_document = document) === null || _document === void 0 ? void 0 : _document.getElementById('__next')) !== null;
  }
};